module.exports = __webpack_public_path__ + "static/media/hindu-prayer.a974d389.mp3";